import { openStudyPendingTasks, openBinderPendingTasks, openBinderUnfiledDocuments, openStudyUnfiledDocuments } from './openStudyBinders';

import styles from '../StudyBinders.scss';

const columnWidth = 'auto';
const minColumnWidth = '100%';
const commonHeaderStyle = {
    width: 'auto',          
    minWidth: '150px',      
    maxWidth: 'none',       
};

const commonCellStyle = {
    width: 'auto',          
    minWidth: '150px',   
    maxWidth: 'none',      
    whiteSpace: 'nowrap',   
    overflow: 'visible',    
};


export const binderStudiesColumnsGenerator = (binderCustomColumns) => {

    const getTitleFromCustomColumns = (key) => {
        const customColumn = binderCustomColumns && binderCustomColumns.find(column => column.key === key);
        return customColumn ? customColumn.label : null;
    };

    return [
        {
            title: getTitleFromCustomColumns('sponsor'),
            field: 'sponsor',
            key: 'sponsor',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.sponsor}>{rowData.sponsor}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('cro'),
            field: 'cro',
            key: 'cro',

            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.cro}>{rowData.cro}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('protocol_trial_id'),
            field: 'protocol',
            key: 'protocol_trial_id',

            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.protocol}>{rowData.protocol}</span>
            )
        },
        {
            title: 'Binder Type',
            field: 'binderType',
            key: 'binder_type',

            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.binderType}>{rowData.binderType}</span>
            )
        },
        {
            title: 'Unfiled Documents',
            field: 'unfiledDocuments',
            key: 'unfiled_documents',

            headerStyle: { ...commonHeaderStyle, textAlign: 'right' },
            cellStyle: {
                width: columnWidth,
                minWidth: minColumnWidth,
                textAlign: 'right',
            },
            render: rowData => (
                <span>
                    {rowData.unfiledDocuments !== 'N/A' && rowData.unfiledDocuments !== '--' ? (
                        <span
                            onClick={() => rowData.isBinder ? openBinderUnfiledDocuments(rowData) : openStudyUnfiledDocuments(rowData)}
                            className={styles.tasksCount}
                            title={rowData.unfiledDocuments}
                        >
                            {rowData.unfiledDocuments}
                        </span>
                    ) : (
                        <span title={rowData.unfiledDocuments}>{rowData.unfiledDocuments}</span>
                    )}
                </span>
            )
        },
        {
            title: 'Pending Tasks',
            field: 'pendingTasks',
            key: 'pending_tasks',

            headerStyle: { ...commonHeaderStyle, textAlign: 'right' },
            cellStyle: {
                width: columnWidth,
                minWidth: minColumnWidth,
                textAlign: 'right',
            },
            render: rowData => (
                <span>
                    {rowData.pendingTasks !== 'N/A' && rowData.pendingTasks !== '--' ? (
                        <span
                            onClick={() => rowData.isBinder ? openBinderPendingTasks(rowData) : openStudyPendingTasks(rowData)}
                            className={styles.tasksCount}>
                            {rowData.pendingTasks}
                        </span>
                    ) : (
                        <span>{rowData.pendingTasks}</span>
                    )}
                </span>
            )
        },
        {
            title: 'Activation Date',
            field: 'activationDate',
            key: 'activation_date',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.activationDate}>{rowData.activationDate}</span>
            )
        },
        {
            title: 'Study Stage',
            field: 'studyStage',
            key: 'study_stage',

            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.studyStage}>{rowData.studyStage}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('disease_group'),
            field: 'diseaseGroup',
            key: 'disease_group',

            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.diseaseGroup}>{rowData.diseaseGroup}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('renewal_date'),
            field: 'renewalDate',
            key: 'renewal_date',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.renewalDate}>{rowData.renewalDate}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('contact'),
            field: 'contact',
            key: 'contact',

            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.contact}>{rowData.contact}</span>
            )
        },
        {
            title: 'Creation Date',
            field: 'createdAt',
            key: 'creation_date',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.createdAt}>{rowData.createdAt}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('ct_gov_number'),
            field: 'ctGovNumber',
            key: 'ct_gov_number',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.ctGovNumber}>{rowData.ctGovNumber}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('IRB_IEC_number'),
            field: 'irbNumber',
            key: 'IRB_IEC_number',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.irbNumber}>{rowData.irbNumber}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('site'),
            field: 'site',
            key: 'site',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.site}>{rowData.site}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('department'),
            field: 'department',
            key: 'department',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.department}>{rowData.department}</span>
            )
        },
        {
            title: 'Site Number',
            field: 'siteNumber',
            key: 'site_number',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.siteNumber}>{rowData.siteNumber}</span>
            )
        },
        {
            title: 'Status',
            field: 'status',
            key: 'status',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.status}>{rowData.status}</span>
            )
        },
        {
            title: getTitleFromCustomColumns('principal_investigator'),
            field: 'primaryInvestigator',
            key: 'principal_investigator',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.primaryInvestigator}>{rowData.primaryInvestigator}</span>
            )
        },

        {
            title: 'Template',
            field: 'template',
            key: 'template',
            headerStyle: commonHeaderStyle,
            cellStyle: commonCellStyle,
            render: (rowData) => (
                <span title={rowData.template}>{rowData.template}</span>
            )
        }
    ];
};